export class Job {
  public id: Number;
  public site_id: Number;
  public name: String;
  public shoot_type: String;
  public classrooms: String;
  public postage_start_date: Number;
  public postage_end_date: Number;
  public estimated_delivery_date : Number;
  public postage_cost: Number;
  public postage_cost_before_deadline: Number;
  public commission: Number;
  public isCommissionPaid: String;
  public description: String;
  public stop_counting_total: String;
  public visable_to_manager: String;
  public isPostageMandatory: String;
  public manager_commission: String;
  public stop_total_count: String;
  public approx_number_of_childrens: String;
  public shoot_days: String;
  public arrival_time: String;
  public proofcards_dispatched: String;
  public orders_dispatched: String;
  public proofcards_tracking_number: String;
  public orders_tracking_number: String;
  public proofcards_dispatched_date: String;
  public orders_dispatched_date: String;
  public assigned_photographer: String;
  public shoot_time: String;
  public job_status: String

  constructor() {}
}

export const job_params: Job = {
  id: null,
  site_id: null,
  name: null,
  shoot_type: null,
  classrooms: null,
  postage_start_date: null,
  postage_end_date: null,
  estimated_delivery_date : null,
  postage_cost: null,
  postage_cost_before_deadline: null,
  commission: null,
  isCommissionPaid: null,
  description: null,
  stop_counting_total: null,
  visable_to_manager: null,
  isPostageMandatory: null,
  manager_commission: null,
  stop_total_count: null,
  approx_number_of_childrens: null,
  shoot_days: null,
  arrival_time: null,
  proofcards_dispatched: null,
  orders_dispatched: null,
  proofcards_tracking_number: null,
  orders_tracking_number: null,
  proofcards_dispatched_date: null,
  orders_dispatched_date: null,
  assigned_photographer: null,
  shoot_time: null,
  job_status : null,
};
